<!-- Copyright (c) 2009-2022. Authors: see NOTICE file.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.-->


<template>
<b-taginput
  :value="value"
  @input="$emit('input', $event)"
  :data="filteredDomains"
  autocomplete
  :open-on-focus="true"
  :field="displayedProperty"
  :placeholder="$t(placeholder)"
  @typing="val => searchString = val"
  @add="searchString = ''"
  :allow-new="allowNew"
  :allow-duplicates="false"
/>
</template>

<script>
import {getWildcardRegexp} from '@/utils/string-utils';

export default {
  name: 'domain-tag-input',
  props: {
    value: Array,
    domains: Array,
    identifier: {
      type: String,
      default: 'id'
    },
    displayedProperty: {
      type: String,
      default: 'name'
    },
    searchedProperty: {
      type: String,
      default: 'name'
    },
    allowNew: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'search-placeholder'
    }
  },
  data() {
    return {
      searchString: ''
    };
  },
  computed: {
    filteredDomains() {
      let selectedIds = this.value.map(v => v[this.identifier]);
      let filtered = this.domains.filter(user => !selectedIds.includes(user[this.identifier]));
      if(this.searchString === '') {
        return filtered;
      }

      let regexp = getWildcardRegexp(this.searchString);

      return filtered.filter(user => regexp.test(user[this.searchedProperty]));
    }
  }
};
</script>
